/**
 * @desc 盘点任务分页列表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inventoryMaster.taskPage.Params, options?: any) {
  return updateResponse(
    http(URL + `/inventoryMaster/taskPage`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
